import { joinDefinedStrings } from './strings'

export type Address = {
    coordinates?: GeoCoordinates
    country: string
    city: string
    street: string
    house_number?: string
    state?: string
    zip?: string
}

export type GeoCoordinates = {
    latitude: number
    longitude: number
}

type Options = Partial<{
    delimiter: string
}>

export const assembleAddressLines = ({ street, house_number, zip, city, state, country }: Partial<Address>) => {
    const addressLines = [
        joinDefinedStrings([street, house_number]),
        joinDefinedStrings([zip, city]),
        joinDefinedStrings([state, country], ', '),
    ]
    return addressLines.filter(Boolean)
}

export const assembleAddressFormat = (
    { street, house_number, zip, city, state, country }: Partial<Address>,
    { delimiter = ' | ' }: Options = {}
) => {
    const partsOfAddress = []
    if (street) {
        partsOfAddress.push(joinDefinedStrings([street, house_number]))
    }
    partsOfAddress.push(joinDefinedStrings([zip, city]))
    partsOfAddress.push(joinDefinedStrings([state, country]))
    return joinDefinedStrings(partsOfAddress, delimiter)
}

export const assembleAddressTitle = ({
    assetTitle,
    street,
    house_number,
}: Pick<Partial<Address>, 'street' | 'house_number'> & { assetTitle?: string }) => {
    const addressLineOne = joinDefinedStrings([street, house_number])
    return assetTitle || addressLineOne
}

export const assembleAssetTitle = ({
    assetTitle,
    street,
    house_number,
    customer_asset_reference,
}: Pick<Partial<Address>, 'street' | 'house_number'> & { assetTitle?: string; customer_asset_reference?: string }) => {
    const assetReference = customer_asset_reference && `[${customer_asset_reference}]`
    const title = assembleAddressTitle({ assetTitle, street, house_number })
    return joinDefinedStrings([assetReference, title])
}

export const assembleAssetCityWithCustomerReference = ({
    city,
    customer_asset_reference,
}: {
    city?: string
    customer_asset_reference?: string
}) => {
    if (!city) {
        return customer_asset_reference ? `[${customer_asset_reference}]` : ''
    }
    return customer_asset_reference ? `[${customer_asset_reference}] ${city}` : city
}
